let supportsPassive = false;
try {
    const opts = Object.defineProperty({}, 'passive', {
        get() {
            supportsPassive = true;
            return true;
        },
    });
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
} catch (e) {
    supportsPassive = false;
}

/**
 * Set scroll event listener using passive listener, for browsers
 * that do not support passive event fallback on default listener
 *
 * @param {function} cb
 * @param {HTMLElement} target
 * @returns {function} - remove event listener
 */

export default function onPassiveScroll(cb, target) {
    var actualTarget = target || window;
    actualTarget.addEventListener('scroll', cb, supportsPassive ? { passive: true } : false);
    return function removeOnScroll() {
        actualTarget.removeEventListener('scroll', cb, supportsPassive ? { passive: true } : false);
    };
}
